var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWChangePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11 12.792C10.4736 12.5623 10.0424 12.1583 9.77878 11.648C9.51521 11.1377 9.43539 10.5522 9.55273 9.98994C9.67008 9.4277 9.97744 8.92302 10.4231 8.56075C10.8688 8.19847 11.4256 8.00071 12 8.00071C12.5744 8.00071 13.1312 8.19847 13.5769 8.56075C14.0226 8.92302 14.3299 9.4277 14.4473 9.98994C14.5646 10.5522 14.4848 11.1377 14.2212 11.648C13.9576 12.1583 13.5264 12.5623 13 12.792V16H11V12.792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWChangePin);
export default __webpack_public_path__ + "static/media/w_changePin.edc3e6209ce4197979e9e39e4cf96520.svg";
export { ForwardRef as ReactComponent };